import { Route } from "react-router-dom";
import { TaskDetail } from "Pages/Admin/Pages/Tasks/Pages/TaskDetail";
import { SwitchWith404 } from "Config/Router";
import { GenericCard } from "Pages/Project/Components/GenericCard";

export const AdminTasks = () => {
  return (
    <GenericCard>
      <SwitchWith404>
        <Route path={`:id`} element={<TaskDetail />} />
        {/* Future: Temporary solution of Not Found redirect handling.
                    Remove when tasks admin is implemented in React. */}
      </SwitchWith404>
    </GenericCard>
  );
};
